//This file contains Process Types For API Call

export const IDLE = 'IDLE';
export const SUCCESS = 'SUCCESS';
export const FAIL = 'FAIL';
export const PROCESSING = 'PROCESSING';
export const INVALID_TOKEN = 'INVALID_TOKEN';
export const RESET_INVALID_TOKEN = 'RESET_INVALID_TOKEN';
export const INVALID_API_URL = 'INVALID_API_URL';
export const RESET_INVALID_API_URL = 'RESET_INVALID_API_URL';